import { Client, Config } from '@bugsnag/js';
import NextAppContext from 'next/app';
import React, { Component } from 'react';

import {BugsnagProvider, IBugsnagNextAppContext} from './context';
import { getOrCreateBugsnagClient } from './utils/getOrCreateBugsnagClient';

export const withBugsnagNextApp = (apiKeyOrOpts: Config) => (
    ComposedComponent: any
): any => {
    class WithBugsnagNextAppWrapper extends Component {
        public static async getInitialProps(
            context: NextAppContext & IBugsnagNextAppContext
        ): Promise<any> {
            let appProps = {
                pageProps: {},
            };

            context.ctx.bugsnag = getOrCreateBugsnagClient(apiKeyOrOpts);

            if (ComposedComponent.getInitialProps) {
                appProps = await ComposedComponent.getInitialProps(context);
            }

            return appProps;
        }

        private bugsnag: Client;

        constructor(props: any) {
            super(props);
            this.bugsnag = getOrCreateBugsnagClient(apiKeyOrOpts);
        }

        public render() {
            const appProps = {
                ...this.props,
                bugsnag: this.bugsnag,
            };

            return (
                <BugsnagProvider value={this.bugsnag}>
                    <ComposedComponent {...appProps} />
                </BugsnagProvider>
            );
        }
    }

    return WithBugsnagNextAppWrapper;
};